var $formCaptcha = $(".js-form_captcha");
var $formCaptchaIcon = $(".js-form_captcha_icon");

$formCaptchaIcon.on("click", function(){
    var src = $(this).siblings(".js-form_captcha").data("src");
    $formCaptcha.attr("src", src + "&" + Date.now())
});

$.each($(".js-form_input"), function(key, value){
    var regex = new RegExp($(this).attr("pattern"));

    if($(value).val() == "" && $(value).attr("required") == "required"){
        $(value).attr("title", $(value).data("required"));

    } else if(!regex.test($(value).val()) && $(value).val() != "" && $(value).data("format") != ""){
        $(value).attr("title", $(value).data("format"));

    } else if($(value).val().length > $(value).attr("maxlength")){
        $(value).attr("title", $(value).data("max"));

    } else{
        $(value).attr("title", "");
    }
});


$.each($(".js-form_select"), function(key, value){
    if($(value).val() == "" && $(value).attr("required") == "required"){
        $(value).attr("title", $(value).data("required"));
    } else{
        $(value).attr("title", "");
    }
});


$(".js-form_input").on("keyup", function(){
    var regex = new RegExp($(this).attr("pattern"), "g");
    var $label = $(this).siblings(".js-form_label");
    var valid = true;

    // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
    var label_text = $(this).attr("label_text");
    if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $(this).attr("placeholder");

    if($(this).val() == "" && $(this).attr("required") == "required"){
        $(this).attr("title", $(this).data("required"));
        valid = false;
    } else if(!regex.test($(this).val()) && $(this).val() != "" && $(this).data("format") != ""){
        $(this).attr("title", $(this).data("format"));
        valid = false;

    } else if($(this).val().length > $(this).attr("maxlength")){
        $(this).attr("title", $(this).data("max"));
        valid = false;

    } else{
        $(this).attr("title", "")
    }

    if(valid){
        $label.text(label_text);
        $label.removeClass("form_label_text-error");
    }
});

$(".js-form_select").on("blur", function(){
    var $label = $(this).siblings(".js-form_label");
    var valid = true;

    // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
    var label_text = $(this).attr("label_text");
    if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $(this).attr("placeholder");

    if($(this).val() == null && $(this).attr("required") == "required"){
        $(this).attr("title", $(this).data("required"));
        valid = false;
    }
    if(!valid){
        $label.addClass("form_label_text-error");
        $label.text(label_text + " - " + $(this).attr("title"));

    } else{
        $label.text(label_text);
        $label.removeClass("form_label_text-error");
    }
});

$(".js-form_input").on("blur", function(){
    var regex = new RegExp($(this).attr("pattern"), "g");
    var $label = $(this).siblings(".js-form_label");
    var valid = true;

    // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
    var label_text = $(this).attr("label_text");
    if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $(this).attr("placeholder");

    if($(this).val() == "" && $(this).attr("required") == "required"){
        $(this).attr("title", $(this).data("required"));
        valid = false;
    } else if(!regex.test($(this).val()) && $(this).val() != "" && $(this).data("format") != ""){
        $(this).attr("title", $(this).data("format"));
        valid = false;
    } else if($(this).val().length > $(this).attr("maxlength")){
        $(this).attr("title", $(this).data("max"));
        valid = false;
    } else{
        $(this).attr("title", "")
    }

    if(!valid){
        $label.addClass("form_label_text-error");
        $label.text(label_text + " - " + $(this).attr("title"));
    } else{
        $label.text(label_text);
        $label.removeClass("form_label_text-error");
    }
});

function prepareUpload(evt) {
    files = evt.target.files; // FileList object
    if(typeof files != "object") return;
    // files is a FileList of File objects. List some properties.
    var output = [];
    var sizeTotal = 0;
    var valid = 1;
    for (var i = 0, f; f = files[i]; i++) {
        sizeTotal += f.size;
        output.push('<li class="js-upload_list_item liste_text_con form_upload_list_item"><i class="liste_icon liste_icon-upload fa fa-file-o" aria-hidden="true"></i>', f.name, ' (',
            formatSizeUnits(f.size), '',
            ')</li><hr class="liste_hr">');
    }

    if(sizeTotal > $(".js-upload").data("max_file") || sizeTotal > $(".js-upload").data("max_post") ){
        $(".js-upload").siblings(".js-form_label").addClass("form_label_text-error");
        $(".js-upload").siblings(".js-form_label").text($(".js-upload").siblings(".js-form_label").text() + " - " + $(".js-upload").data("error"));
        $(".js-contact_form_successblock").hide();
        $(".js-contact_form_errorblock").show();
        $(".js-contact_form_errorblock").html($taenzerFormSubmit.data("error").replace('#anz', 1));
        valid = 0;
    }else if(i > 10){
        $(".js-upload").siblings(".js-form_label").addClass("form_label_text-error");
        $(".js-upload").siblings(".js-form_label").text($(".js-upload").siblings(".js-form_label").text() + " - " + $(".js-upload").data("error_max_files"));
        $(".js-contact_form_successblock").hide();
        $(".js-contact_form_errorblock").show();
        $(".js-contact_form_errorblock").html($taenzerFormSubmit.data("error").replace('#anz', 1));
        valid = 0;
    }else{
        $(".js-contact_form_errorblock").hide();
        $(".js-upload").siblings(".js-form_label").text($(".js-upload").siblings(".js-form_label").attr("placeholder"));
        $(".js-upload").siblings(".js-form_label").removeClass("form_label_text-error");
        valid = 1;
    }

    $(".js-upload_size").val(sizeTotal);
    $(".js-upload_valid").val(valid);

    if(i>0)$('.js-upload_list').html('<ul class="liste_con-upload"><hr class="liste_hr">' + output.join('') + '</ul>');
}

$(".js-form_upload_clear").on('click',function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".js-upload").wrap('<form>');
    $(".js-upload").closest('form').get(0).reset();
    $(".js-upload").unwrap();
    $(".js-upload_list ").hide();
});

function formatSizeUnits(bytes){
    if      (bytes>=1073741824) {bytes=(bytes/1073741824).toFixed(2)+' GB';}
    else if (bytes>=1048576)    {bytes=(bytes/1048576).toFixed(2)+' MB';}
    else if (bytes>=1024)       {bytes=(bytes/1024).toFixed(2)+' KB';}
    else if (bytes>1)           {bytes=bytes+' bytes';}
    else if (bytes==1)          {bytes=bytes+' byte';}
    else                        {bytes='0 byte';}
    return bytes;
}
